import { Button } from "@mui/material";

import AlertConfirm from "commons/ui/alert/AlertConfirm";
import DataTableSimple from "commons/ui/datatable/DataTableSimple";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import WorkOffersTableFilters from "components/subComponents/WorkOffersTableFilters";

import useWorkOffersList from "hooks/list/useWorkOffersList";

function ElencoOfferte() {
    const workOffersListHook = useWorkOffersList();

    const { navigateToNewWorkOffer, alertConfirmHook, dataTableHook } = workOffersListHook;

    return (
        <GridColumn>
            <AlertConfirm alertConfirmHook={alertConfirmHook} />

            <Paper className={"table-with-filters"}>
                <WorkOffersTableFilters workOffersListHook={workOffersListHook} />

                <DataTableSimple dataTableHook={dataTableHook} dontUsePaper />
            </Paper>

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={navigateToNewWorkOffer}>
                        Nuova offerta di lavoro
                    </Button>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default ElencoOfferte;
